// Author Lin
// Date 2021-11-03 10:38:11

class MintalMesPrdSmeltingFurnaceLiningTemperature {
        constructor({
                id = null,
                measureTime = '',
                locationId = '',
                locationName = '',
                furnaceId = '',
                furnaceName = '',
                position11h = '',
                position11c = '',
                position12h = '',
                position12c = '',
                position13h = '',
                position13c = '',
                position14h = '',
                position14c = '',
                position15h = '',
                position15c = '',
                position22h = '',
                position22c = '',
                position23h = '',
                position23c = '',
                position24h = '',
                position24c = '',
                position25h = '',
                position25c = '',
                position32h = '',
                position32c = '',
                position33h = '',
                position33c = '',
                position34h = '',
                position34c = '',
                position35h = '',
                position35c = '',
                position114h = '',
                position114c = '',
                position124h = '',
                position124c = '',
                position131h = '',
                position131c = '',
                position132h = '',
                position132c = '',
                position133h = '',
                position133c = '',
                position134h = '',
                position134c = '',
                position150h = '',
                position150c = '',
                position152h = '',
                position152c = '',
                position153h = '',
                position153c = '',
                position155h = '',
                position155c = '',
                position214h = '',
                position214c = '',
                position224h = '',
                position224c = '',
                position231h = '',
                position231c = '',
                position232h = '',
                position232c = '',
                position233h = '',
                position233c = '',
                position234h = '',
                position234c = '',
                position250h = '',
                position250c = '',
                position251h = '',
                position251c = '',
                position252h = '',
                position252c = '',
                position253h = '',
                position253c = '',
                position254h = '',
                position254c = '',
                position255h = '',
                position255c = '',
                position414 = '',
                position424 = '',
                position434 = '',
                position4141 = '',
                position4241 = '',
                position4341 = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.measureTime = measureTime;
            this.locationId = locationId;
            this.locationName = locationName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.position11h = position11h;
            this.position11c = position11c;
            this.position12h = position12h;
            this.position12c = position12c;
            this.position13h = position13h;
            this.position13c = position13c;
            this.position14h = position14h;
            this.position14c = position14c;
            this.position15h = position15h;
            this.position15c = position15c;
            this.position22h = position22h;
            this.position22c = position22c;
            this.position23h = position23h;
            this.position23c = position23c;
            this.position24h = position24h;
            this.position24c = position24c;
            this.position25h = position25h;
            this.position25c = position25c;
            this.position32h = position32h;
            this.position32c = position32c;
            this.position33h = position33h;
            this.position33c = position33c;
            this.position34h = position34h;
            this.position34c = position34c;
            this.position35h = position35h;
            this.position35c = position35c;
            this.position114h = position114h;
            this.position114c = position114c;
            this.position124h = position124h;
            this.position124c = position124c;
            this.position131h = position131h;
            this.position131c = position131c;
            this.position132h = position132h;
            this.position132c = position132c;
            this.position133h = position133h;
            this.position133c = position133c;
            this.position134h = position134h;
            this.position134c = position134c;
            this.position150h = position150h;
            this.position150c = position150c;
            this.position152h = position152h;
            this.position152c = position152c;
            this.position153h = position153h;
            this.position153c = position153c;
            this.position155h = position155h;
            this.position155c = position155c;
            this.position214h = position214h;
            this.position214c = position214c;
            this.position224h = position224h;
            this.position224c = position224c;
            this.position231h = position231h;
            this.position231c = position231c;
            this.position232h = position232h;
            this.position232c = position232c;
            this.position233h = position233h;
            this.position233c = position233c;
            this.position234h = position234h;
            this.position234c = position234c;
            this.position250h = position250h;
            this.position250c = position250c;
            this.position251h = position251h;
            this.position251c = position251c;
            this.position252h = position252h;
            this.position252c = position252c;
            this.position253h = position253h;
            this.position253c = position253c;
            this.position254h = position254h;
            this.position254c = position254c;
            this.position255h = position255h;
            this.position255c = position255c;
            this.position414 = position414;
            this.position424 = position424;
            this.position434 = position434;
            this.position4141 = position4141;
            this.position4241 = position4241;
            this.position4341 = position4341;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingFurnaceLiningTemperature();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.measureTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.furnaceId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position11h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position11h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position11c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position11c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position12h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position12h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position12c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position12c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position13h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position13h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position13c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position13c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position14h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position14h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position14c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position14c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position15h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position15h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position15c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position15c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position22h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position22h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position22c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position22c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position23h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position23h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position23c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position23c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position24h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position24h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position24c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position24c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position25h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position25h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position25c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position25c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position32h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position32h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position32c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position32c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position33h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position33h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position33c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position33c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position34h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position34h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position34c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position34c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position35h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position35h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position35c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position35c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position114h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position114h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position114c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position114c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position124h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position124h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position124c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position124c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position131h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position131h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position131c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position131c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position132h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position132h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position132c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position132c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position133h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position133h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position133c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position133c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position134h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position134h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position134c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position134c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position150h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position150h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position150c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position150c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position152h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position152h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position152c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position152c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position153h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position153h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position153c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position153c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position155h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position155h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position155c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position155c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position214h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position214h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position214c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position214c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position224h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position224h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position224c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position224c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position231h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position231h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position231c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position231c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position232h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position232h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position232c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position232c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position233h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position233h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position233c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position233c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position234h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position234h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position234c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position234c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position250h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position250h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position250c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position250c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position251h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position251h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position251c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position251c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position252h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position252h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position252c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position252c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position253h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position253h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position253c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position253c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position254h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position254h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position254c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position254c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position255h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position255h',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position255c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position255c',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position414',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position414',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position424',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position424',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position434',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position434',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position4141',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position4141',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position4241',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position4241',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'position4341',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.position4341',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            measureTimeRteFilter : '',
            measureTimeLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            position11cFilter : '',
            position11hFilter : '',
            position12cFilter : '',
            position12hFilter : '',
            position13cFilter : '',
            position13hFilter : '',
            position14cFilter : '',
            position14hFilter : '',
            position15cFilter : '',
            position15hFilter : '',
            position22cFilter : '',
            position22hFilter : '',
            position23cFilter : '',
            position23hFilter : '',
            position24cFilter : '',
            position24hFilter : '',
            position25cFilter : '',
            position25hFilter : '',
            position32cFilter : '',
            position32hFilter : '',
            position33cFilter : '',
            position33hFilter : '',
            position34cFilter : '',
            position34hFilter : '',
            position35cFilter : '',
            position35hFilter : '',
            position114cFilter : '',
            position114hFilter : '',
            position124cFilter : '',
            position124hFilter : '',
            position131cFilter : '',
            position131hFilter : '',
            position132cFilter : '',
            position132hFilter : '',
            position133cFilter : '',
            position133hFilter : '',
            position134cFilter : '',
            position134hFilter : '',
            position150cFilter : '',
            position150hFilter : '',
            position152cFilter : '',
            position152hFilter : '',
            position153cFilter : '',
            position153hFilter : '',
            position155cFilter : '',
            position155hFilter : '',
            position214cFilter : '',
            position214hFilter : '',
            position224cFilter : '',
            position224hFilter : '',
            position231cFilter : '',
            position231hFilter : '',
            position232cFilter : '',
            position232hFilter : '',
            position233cFilter : '',
            position233hFilter : '',
            position234cFilter : '',
            position234hFilter : '',
            position250cFilter : '',
            position250hFilter : '',
            position251cFilter : '',
            position251hFilter : '',
            position252cFilter : '',
            position252hFilter : '',
            position253cFilter : '',
            position253hFilter : '',
            position254cFilter : '',
            position254hFilter : '',
            position255cFilter : '',
            position255hFilter : '',
            position414Filter : '',
            position424Filter : '',
            position434Filter : '',
            position4141Filter : '',
            position4241Filter : '',
            position4341Filter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'measureTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.filter.measureTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'measureTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.filter.measureTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.measureTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'position11h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position11h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position11c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position11c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position12h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position12h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position12c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position12c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position13h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position13h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position13c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position13c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position14h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position14h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position14c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position14c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position15h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position15h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position15c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position15c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position22h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position22h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position22c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position22c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position23h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position23h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position23c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position23c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position24h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position24h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position24c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position24c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position25h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position25h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position25c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position25c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position32h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position32h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position32c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position32c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position33h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position33h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position33c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position33c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position34h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position34h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position34c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position34c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position35h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position35h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position35c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position35c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position114h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position114h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position114c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position114c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position124h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position124h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position124c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position124c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position131h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position131h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position131c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position131c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position132h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position132h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position132c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position132c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position133h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position133h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position133c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position133c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position134h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position134h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position134c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position134c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position150h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position150h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position150c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position150c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position152h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position152h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position152c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position152c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position153h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position153h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position153c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position153c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position155h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position155h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position155c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position155c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position214h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position214h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position214c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position214c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position224h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position224h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position224c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position224c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position231h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position231h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position231c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position231c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position232h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position232h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position232c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position232c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position233h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position233h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position233c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position233c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position234h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position234h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position234c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position234c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position250h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position250h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position250c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position250c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position251h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position251h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position251c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position251c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position252h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position252h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position252c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position252c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position253h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position253h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position253c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position253c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position254h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position254h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position254c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position254c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position255h',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position255h',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position255c',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position255c',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position414',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position414',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position424',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position424',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position434',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position434',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position4141',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position4141',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position4241',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position4241',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'position4341',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.position4341',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceLiningTemperature.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingFurnaceLiningTemperature, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        